export enum EnvironmentOptionsEnum {
    Production = 1,
    Homologation = 2
}